export default function TestimonialsSection() {
  const achievements = [
    { school: '東京福祉大学', count: 51, period: '2024年4月' },
    { school: 'リハビリテーションカレッジ島根', count: 3, period: '2024年4月' },
    { school: '京都情報大学大学', count: 2, period: '2024年4月' },
    { school: '城西国際大学', count: 8, period: '2024年4月' },
    { school: '学校法人21世紀アカデメイア', count: 20, period: '2024年4月' },
    { school: '学校法人創志学園', count: 6, period: '2024年4月' },
    { school: '学校法人白萩学園', count: 12, period: '2024年4月' },
    { school: '千葉科学大学', count: 1, period: '2024年4月' },
    { school: 'サンシャインランゲージスクール', count: 25, period: '2024年4月・7月' },
    { school: '東京こころ日本語学校', count: 56, period: '2024年4月・10月' },
    { school: '朝日アカデミ学校', count: 5, period: '2024年4月' },
    { school: 'その他進学', count: 35, period: '2024年4月・7月・10月' }
  ];

  const totalStudents = achievements.reduce((sum, item) => sum + item.count, 0);

  return (
    <section className="py-24 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs text-gray-500 mb-4">/ Achievements</p>
          <h2 className="text-4xl md:text-5xl font-light mb-6" style={{ fontFamily: 'serif' }}>
            実績報告
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-8">
            提携校向け実績報告（2025年）
          </p>
          <div className="inline-flex items-center space-x-4 bg-teal-600 text-white px-8 py-4 rounded-full">
            <i className="ri-user-star-line text-3xl"></i>
            <div className="text-left">
              <p className="text-sm opacity-90">2025年度 進学支援実績</p>
              <p className="text-3xl font-bold">{totalStudents}名</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {achievements.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 hover:shadow-lg transition-all duration-300 border border-amber-100"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <h3 className="font-medium text-amber-900 mb-2 text-base leading-snug">
                    {item.school}
                  </h3>
                  <p className="text-xs text-gray-500">{item.period}</p>
                </div>
                <div className="text-right">
                  <p className="text-3xl font-bold text-teal-600">{item.count}</p>
                  <p className="text-xs text-gray-500">名</p>
                </div>
              </div>
              <div className="w-full bg-amber-100 rounded-full h-2">
                <div
                  className="bg-teal-600 h-2 rounded-full transition-all duration-500"
                  style={{ width: `${(item.count / 56) * 100}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-teal-600 to-teal-500 text-white rounded-2xl p-12 max-w-4xl mx-auto">
            <h3 className="text-3xl font-light mb-6" style={{ fontFamily: 'serif' }}>
              今後の展望
            </h3>
            <p className="text-lg leading-relaxed opacity-95">
              虹橋株式会社は、これからも学生の皆様の成長と成功をサポートするため、<br />
              サービスの充実と質の向上に努めてまいります。<br />
              提携校の皆様と共に、学生の未来を支えていけるよう、<br />
              引き続きご協力を賜りますようお願い申し上げます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}